<template lang="pug">
  div.report-download
    report-views
    contact-us
</template>

<script>
import ReportViews from './ReportViews'
import ContactUs from '../components/ContactUs'
export default {
  name: 'ReportDownload',
  components: {
    ReportViews,
    ContactUs
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
  .report-download{
    display: flex;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/ReportDownload/ReportDownload.vue